import { UpdateCargoClaimAttachmentsCommand } from "@amzn/ttechclaimintakeservice-client";

import { getAuthenticationToken } from "../../auth/helpers";
import { setupClaimIntakeClient } from "../setup/setupClaimIntakeClient";
import { MetricsPublisher } from "../../metrics/metrics";
import { ProcessedApiResponse } from "../types";
import { FormStateType } from "src/forms/types";
import { CargoClaimAdditionalFields } from "src/app/Cargo/types";
import { updateCargoClaimAttachmentsModelBuilder } from "./CargoClaimModelBuilder";

export async function updateCargoClaimAttachmentsService(
  formState: FormStateType,
  additionalFields: CargoClaimAdditionalFields
) {
  const token = await getAuthenticationToken();
  if (!token) {
    return null;
  }

  const commandInput = updateCargoClaimAttachmentsModelBuilder(formState, additionalFields);
  const client = setupClaimIntakeClient(token);
  const command = new UpdateCargoClaimAttachmentsCommand(commandInput);
  const metricsPublisher = new MetricsPublisher("api.updateCargoClaim");

  return await client
    .send(command)
    .then((response) => {
      const resp = response as typeof response & { warningList?: string[]; claimNumber?: string };
      const statusCode = resp?.$metadata?.httpStatusCode?.toString();
      const processedResponse: ProcessedApiResponse = {
        statusCode,
        warningList: resp.warningList,
        data: [
          {
            fieldName: "Claim Reference Number",
            fieldValue: resp.claimNumber,
          },
        ],
      };
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderSuccessMetrics();
      return processedResponse;
    })
    .catch((error) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderFatalMetrics();
      throw error;
    });
}
